export const emptyImage = `/images/empty.jpg`;

export const permission = {};

export const productType = {
    Subscription: 1,
    Certificate: 2,
    Booking: 3
};

export const qtyClients = [1,2,3,4,5,6,7,8,9,10];

export const paymentSystem = {
    Sbrf: 1,
    Raif: 2,
    Credit: 3,
    TinkoffCard: 4,
    CloudPayments: 5,
    SberPay: 6,
};

export function hasPermission(permissions, permission) {
    if (!permissions) return false;

    let value = permissions[permission - 1];
    return value === 1;
}

export const getPermissionLabel = (code) => {
    switch (code) {
        default:
            return '';
    }
};

//** Проверка есть-ли оплата по карте для компании */
export const getHasCompanyCard = company => company.paySbrf || company.payTinkoffCard || company.payCloudPayments;

//** Получить тип оплаты по карте для компании */
export const getCompanyCardPaymentSystem = company => {
    if (company.paySbrf) return paymentSystem.Sbrf;
    if (company.payTinkoffCard) return paymentSystem.TinkoffCard;
    if (company.payCloudPayments) return paymentSystem.CloudPayments;
    return null;
}

//** Если autopay == false то проверяет есть-ли оплата по карте для компании, иначе проверяет что оплата по карте == paymentSystem.TinkoffCard */
export const getCompanyCardAutopay = (company, autopay) => {
    if (!autopay) return getHasCompanyCard(company);
    return getCompanyCardPaymentSystem(company) === paymentSystem.TinkoffCard || getCompanyCardPaymentSystem(company) === paymentSystem.CloudPayments;
}